<template>
  <v-tooltip
    v-if="schedule && schedule.ccCwbtw && schedule.ccCwbtw.wxLevel"
    bottom
  >
    <template #activator="{ on }">
      <span v-on="on">
        <img
          v-if="schedule.ccCwbtw"
          :src="`https://static.kkren.com.tw/static/images/weather-icons/${schedule.ccCwbtw.wxLevel}.svg`"
          :width="width||25"
          style="vertical-align: middle;"
        >
      </span>
    </template>
    <span>
      {{ schedule.cc | dateFormat('MM月DD日') }} 台北 {{ schedule.ccCwbtw.wxName }}
      <span v-if="hasRain(schedule.ccCwbtw.wxLevel)">請注意加裝防水袋</span>
    </span>
  </v-tooltip>
</template>
<script>
import { hasRain } from '@g/utils'
export default {
  props: {
    schedule: Object,
    width: String,
  },
  data () {
    return {
      hasRain,
    }
  },
}
</script>
